module.exports = __webpack_public_path__ + "img/Syrenis-red.ff9addb8.svg";